export enum CUSTOM_ROUTES {
  ANALYTICS = "/analytics",
  SUPPORT = "/support",
}
